<template>
  <div>
    <div class="tab-custom flex-col md:flex-col lg:flex-row flex">
      <a
        class="tab-head tablinks flex-1"
        v-for="tab in tabs"
        :key="tab"
        v-bind:class="{
          'active': activeTab === tab
        }"
        v-on:click="switchTab(tab)"
      >
        <slot :name="tabHeadSlotName(tab)">{{ tab }} </slot>
      </a>
    </div>
    <div class="tab-content-wrap">
      <div class="tabcontent" style="display: block;">
        <slot :name="tabPanelSlotName"> </slot>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    initialTab: String,
    tabs: Array
  },
  data () {
    return {
      activeTab: this.initialTab
    }
  },
  computed: {
    tabPanelSlotName () {
      return `tab-panel-${this.activeTab}`
    }
  },
  methods: {
    tabHeadSlotName (tabName) {
      return `tab-head-${tabName}`
    },

    switchTab (tabName) {
      this.activeTab = tabName
    }
  }
}
</script>
